import { Routes } from '@angular/router';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';

export const applicationsRoutes: Routes = [
    {
        path: 'applications',
        children: [
            {
                path: 'omc-applications',
                loadComponent: () => import('./omc-applications/omc-applications.component').then(c => c.OmcApplicationsComponent),
                data: { title: 'OMC Applications' }
            },
            {
                path: 'omc-applications/:id/contract-review',
                loadComponent: () => import('./omc-applications/omc-contract-review/omc-contract-review.component').then(c => c.OmcContractReviewComponent),
                data: { title: 'OMC Contract Review' }
            },
            {
                path: 'omc-applications/:id/deregister',
                loadComponent: () => import('./omc-applications/omc-deregistration/omc-deregistration.component').then(c => c.OmcDeregistrationComponent),
                data: { title: 'Deregister OMC', enforcementType: 'DEREGISTRATION' }
            },
            {
                path: 'omc-applications/:id/suspend',
                loadComponent: () => import('./omc-applications/omc-deregistration/omc-deregistration.component').then(c => c.OmcDeregistrationComponent),
                data: { title: 'Suspend OMC', enforcementType: 'SUSPENSION' }
            },
            {
                path: 'omc-applications/:id/remove-suspension',
                loadComponent: () => import('./omc-applications/omc-deregistration/omc-deregistration.component').then(c => c.OmcDeregistrationComponent),
                data: { title: 'Remove Suspension', enforcementType: 'SUSPENSION_REMOVAL' }
            },
            {
                path: 'omc-applications/:id/deactivate',
                loadComponent: () => import('./omc-applications/omc-deregistration/omc-deregistration.component').then(c => c.OmcDeregistrationComponent),
                data: { title: 'Deactivate OMC', enforcementType: 'DEACTIVATION' }
            },
            {
                path: 'omc-applications/:id',
                loadComponent: () => import('./omc-applications/omc-application-details/omc-application-details.component').then(c => c.OmcApplicationDetailsComponent),
                data: { title: 'OMC Application Details' }
            },
            {
                path: 'omc-terminal-agreements',
                loadComponent: () => import('./omc-terminal-agreements/omc-terminal-agreements.component').then(c => c.OmcTerminalAgreementsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'OMC Terminal Agreements',
                    permissions: {
                        only: ['ROLE_VIEW_OMC_TERMINAL_AGREEMENT'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'omc-terminal-agreements/:id',
                loadComponent: () => import('./omc-terminal-agreements/omc-terminal-agreement-details/omc-terminal-agreement-details.component').then(c => c.OmcTerminalAgreementDetailsComponent),
                data: { title: 'Terminal Agreement Details' }
            },
            {
                path: 'supplier-applications',
                loadComponent: () => import('./supplier-applications/supplier-applications.component').then(c => c.SupplierApplicationsComponent),
                data: { title: 'Supplier Applications' }
            },
            {
                path: 'supplier-applications/:id',
                loadComponent: () => import('./supplier-applications/supplier-application-details/supplier-application-details.component').then(c => c.SupplierApplicationDetailsComponent),
                data: { title: 'Supplier Application Details' }
            },
            {
                path: 'agent-applications',
                loadComponent: () => import('./agent-applications/agent-applications.component').then(c => c.AgentApplicationsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Agent Applications',
                    permissions: {
                        only: ['ROLE_VIEW_AGENT_APPLICATION'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'agent-applications/:id',
                loadComponent: () => import('./agent-applications/agent-application-details/agent-application-details.component').then(c => c.AgentApplicationDetailsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Agent Application Details',
                    permissions: {
                        only: ['ROLE_VIEW_AGENT_APPLICATION'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },

            {
                path: 'terminal-registration-requests',
                loadComponent: () => import('@modules/applications/terminal-registration-requests/terminal-registration-requests.component').then(c => c.TerminalRegistrationRequestsComponent),
                data: { title: 'Terminal Registration Requests' }
            },
            {
                path: 'terminal-registration-requests/:id',
                loadComponent: () => import('@modules/applications/terminal-registration-requests/terminal-registration-request-details/terminal-registration-request-details.component').then(c => c.TerminalRegistrationRequestDetailsComponent),
                data: { title: 'Terminal Registration Request Details' }
            },
            {
                path: 'omc-contracts',
                loadComponent: () => import('@modules/applications/omc-contracts/omc-contracts.component').then(c => c.OmcContractsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'OMC Contracts',
                    permissions: {
                        only: ['ROLE_VIEW_OMC_CONTRACT'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'non-bps-applications',
                loadComponent: () => import('./non-bps-applications/non-bps-applications.component').then(c => c.NonBpsApplicationsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Non-BPS Applications',
                    permissions: {
                        only: ['ROLE_NON_BPS_APPLICATIONS_VIEW'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'non-bps-applications/:id',
                loadComponent: () => import('./non-bps-applications/non-bps-application-details/non-bps-application-details.component').then(c => c.NonBpsApplicationDetailsComponent),
                data: { title: 'Non-BPS Application Details' }
            },
            {
                path: 'non-bps-discharge-windows',
                loadComponent: () => import('./non-bps-product-requests/non-bps-product-requests.component').then(c => c.NonBpsDischargeWindowsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Non-BPS Discharge Windows',
                    permissions: {
                        only: ['ROLE_NON_BPS_DISCHARGE_WINDOW_REQUEST_BO_VIEW'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'non-bps-discharge-windows/:id',
                loadComponent: () => import('./non-bps-product-requests/non-bps-discharge-window-details/non-bps-discharge-window-details.component').then(c => c.NonBpsDischargeWindowDetailsComponent),
                data: { title: 'Non-BPS Discharge Window Details' }
            },
            {
                path: 'private-transit-cargo',
                loadComponent: () => import('./private-transit-cargo/private-transit-cargo-list.component').then(c => c.InternalPrivateTransitCargoListComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Private Transit Cargo',
                    permissions: { only: ['ROLE_VIEW_PRIVATE_TRANSIT_CARGO'], redirectTo: AUTH_REDIRECT_ROUTE }
                }
            },
            {
                path: 'private-transit-cargo/:id',
                loadComponent: () => import('./private-transit-cargo/private-transit-cargo-details.component').then(c => c.PrivateTransitCargoDetailsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Private Transit Cargo Review',
                    permissions: { only: ['ROLE_VIEW_PRIVATE_TRANSIT_CARGO'], redirectTo: AUTH_REDIRECT_ROUTE }
                }
            },
            {
                path: 'vessel-nominations',
                loadComponent: () => import('./vessel-nominations/vessel-nominations.component').then(c => c.VesselNominationsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Vessel Nominations',
                    permissions: {
                        only: ['ROLE_VIEW_VESSEL_NOMINATION'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            },
            {
                path: 'vessel-nominations/:id',
                loadComponent: () => import('./vessel-nominations/vessel-nomination-details/vessel-nomination-details.component').then(c => c.MisVesselNominationDetailsComponent),
                canActivate: [ngxPermissionsGuard],
                data: {
                    title: 'Vessel Nomination Review',
                    permissions: {
                        only: ['ROLE_VIEW_VESSEL_NOMINATION'],
                        redirectTo: AUTH_REDIRECT_ROUTE
                    }
                }
            }
        ]
    }
];
